import { render, staticRenderFns } from "./TournamentsManagement.vue?vue&type=template&id=650cf6e2&scoped=true"
import script from "./TournamentsManagement.vue?vue&type=script&lang=js"
export * from "./TournamentsManagement.vue?vue&type=script&lang=js"
import style0 from "./TournamentsManagement.vue?vue&type=style&index=0&id=650cf6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650cf6e2",
  null
  
)

export default component.exports